/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { createContext, useContext, useState, useCallback } from "react";

import { useNavigate } from "react-router-dom";

export const LayoutContext = createContext();

export const LayoutProvider = (props) => {
    const navigate = useNavigate();
    const [alert, setAlert] = useState({
        open: false,
        message: "",
        severity: "error",
    });

    const [loader, setLoader] = useState({
        open: false,
        message: "Loading...",
    });

    const [menuClientOpen, setMenuClientOpen] = useState(false);
    const [menuDashboardOpen, setMenuDashboardOpen] = useState(true);

    const [detailDashboardOpen, setDetailDashboardOpen] = useState(true);
    const [clavePaginaActual, setClavePaginaActual] = useState("");
    const [grupoMenuActual, setGrupoMenuActual] = useState("");

    const handleOpenDetailDashboard = useCallback(() => {
        setDetailDashboardOpen(true);
    }, []);

    const handleCloseDetailDashboard = useCallback(() => {
        setDetailDashboardOpen(false);
    }, []);

    const handleOpenMenuClient = useCallback(() => {
        setMenuClientOpen(true);
    }, []);

    const handleCloseMenuClient = useCallback(() => {
        setMenuClientOpen(false);
    }, []);

    const handleOpenMenuDashboard = useCallback(() => {
        setMenuDashboardOpen(true);
    }, []);

    const handleCloseMenuDashboard = useCallback(() => {
        setMenuDashboardOpen(false);
    }, []);

    const handleOpenAlert = useCallback((message, severity = "error") => {
        setAlert({
            open: true,
            message:message,
            severity:severity,
        });
    }, []);

    const handleCloseAlert = useCallback(() => {
        setAlert({
            ...alert,
            open: false,
        });
    }, [alert]);

    const handleOpenLoader = useCallback((message) => {
        setLoader({
            open: true,
            message,
        });
    }, []);

    const handleCloseLoader = useCallback(() => {
        setLoader({
            ...loader,
            open: false,
        });
    }, [loader]);

    const handleClickGoTo = useCallback((value) => {
        navigate(value);
    }, [navigate]);

    const handleChangeTitle = useCallback((value) => {
        document.querySelector("title").innerHTML = "title - " + value;
    }, []);

    const handleChangeClavePaginaActual = useCallback((value) => {
        setClavePaginaActual(value);
    }, []);

    const handleChangeGrupoMenu = useCallback((value) => {
        setGrupoMenuActual(value);
    }, []);

    return (
        <LayoutContext.Provider
            value={{
                alert,
                loader,
                menuClientOpen,
                menuDashboardOpen,
                detailDashboardOpen,
                clavePaginaActual,
                handleOpenDetailDashboard,
                handleCloseDetailDashboard,
                handleOpenMenuDashboard,
                handleCloseMenuDashboard,
                handleOpenMenuClient,
                handleCloseMenuClient,
                handleOpenAlert,
                handleCloseAlert,
                handleOpenLoader,
                handleCloseLoader,
                handleClickGoTo,
                handleChangeTitle,
                handleChangeClavePaginaActual,
                handleChangeGrupoMenu,
                grupoMenuActual,
            }}
        >
            {props.children}
        </LayoutContext.Provider>
    );
};

export const useLayout = () => useContext(LayoutContext);
